
import { Component, Prop, Vue } from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCogs } from '@fortawesome/free-solid-svg-icons/faCogs';
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons/faMobileAlt';
import { faVuejs } from '@fortawesome/free-brands-svg-icons/faVuejs';
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons/faGraduationCap';

// @ts-ignore
library.add(faCogs, faMobileAlt, faVuejs, faGraduationCap);

@Component({
    components: { FontAwesomeIcon },
})
export default class WhatIDo extends Vue {
}
